const t = ["hours", "minutes", "seconds"], E = "EP_PICKER_BASE", n = "ElPopperOptions", o = /* @__PURE__ */ Symbol("commonPickerContextKey"), e = "HH:mm:ss", Y = "YYYY-MM-DD", _ = {
  date: Y,
  dates: Y,
  week: "gggg[w]ww",
  year: "YYYY",
  years: "YYYY",
  month: "YYYY-MM",
  months: "YYYY-MM",
  datetime: `${Y} ${e}`,
  monthrange: "YYYY-MM",
  yearrange: "YYYY",
  daterange: Y,
  datetimerange: `${Y} ${e}`
};
export {
  Y as DEFAULT_FORMATS_DATE,
  _ as DEFAULT_FORMATS_DATEPICKER,
  e as DEFAULT_FORMATS_TIME,
  E as PICKER_BASE_INJECTION_KEY,
  n as PICKER_POPPER_OPTIONS_INJECTION_KEY,
  o as ROOT_COMMON_PICKER_INJECTION_KEY,
  t as timeUnits
};
